import { Component, HostBinding } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Backoffice';
  @HostBinding('class') hostClass = `${environment.name}`;
}
